import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import "../../styles.css";
import Vectorsorting from "../../assets/Vectorsorting.svg";
import ShimmerLoader from "../../loading";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import CustomPagination from "../../components/CustomWidgets/CustomPagination";
import { useSelector } from "react-redux";
const SettlementReportTable = ({ additionalData, pagination }) => {
  const { t, i18n } = useTranslation();
  const [flag, setflag] = useState(false);
  const navigate = useNavigate();

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  )


  const openOrderList = (id) => {
    navigate(`/vendorDetails?id=${id}`);
  };

  const data = useMemo(
    () =>
      //   additionalData?.status
      //     ? additionalData?.all_product
      additionalData || [],
    [additionalData]
  );
  useEffect(() => {
    if (additionalData?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setflag(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [additionalData, flag]);

  const formatSessionState = state => {
    if (!state) return '';

    return state
      .split('_') // Split by underscore
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(' '); // Join the words with a space
  };
  const columns = useMemo(
    () => [
      {
        Header: (t("Month")),

        //  width: "6%", // Add this line
        accessor: "month",
        headerClassName: "text-start",
        Cell: ({ row }) => (
          <div className="text-start justify-start w-28">{row.original.month}</div>
        ),
      },
      {
        Header: (t("Amount Paid")),

        //  width: "6%", // Add this line
        //  width: "7%", // Add this line
        accessor: "amount_paid",
        headerClassName: "text-start",
        Cell: ({ row }) => (
          <div className="text-start justify-start w-28">{`EGP ${row.original.amount_paid}`}</div>
        ),
      },
      {
        id: "reatier_earning", // unique ID
        Header: t("Retailer Earning"),
        accessor: "retailer_earning", // still using the same data field
        headerClassName: "text-start",
        Cell: ({ row }) => {
          const value = row.original.retailer_earning;
          return (
            <div className="text-start justify-start w-28">
              {value < 0 ? `EGP ${value}` : '--'}
            </div>
          );
        },
      },
      {
        id: "myginne_earning", // unique ID
        Header: t("myGINNE Earning"),
        accessor: "retailer_earning", // same data field
        headerClassName: "text-start",
        Cell: ({ row }) => {
          const value = row.original.retailer_earning;
          return (
            <div className="text-start justify-start w-28">
              {value > 0 ? `EGP ${value}` : '--'}
            </div>
          );
        },
      },

      {
        Header: (t("Transaction ID")),

        //  width: "7%", // Add this line
        //  width: "7%", // Add this line
        accessor: "transaction_id",
        headerClassName: "text-start",
        Cell: ({ row }) => (
          <div className="text-start justify-start w-28">{`${row.original.transaction_id}`}</div>
        ),
      },
      // {
      //       Header: (t("Settlement Status")),

      //    width: "9%", // Add this line
      //   //  width: "7%", // Add this line
      //   accessor: "settlement_status",
      //   headerClassName: "text-start",
      //   Cell: ({ row }) => (
      //     <div className="text-start justify-start w-28">{t(formatSessionState(row.original.settlement_status))}</div>
      //   ),
      // },
      //  { Header: (t("Week Range")), accessor: "week_range",Cell: ({ value }) => value  },
      //   { Header: (t("Retailer Earning")), accessor: "retailer_earning",Cell: ({ value }) => `EGP ${value.toFixed(2)}`},
      //   { Header: (t("Collected By Retailer")), accessor: "collected_by_retailer",Cell: ({ value }) => `EGP ${value.toFixed(2)}`},
      //   { Header: (t("Payable To Retailer")), accessor: "payable_to_retailer",Cell: ({ value }) => `EGP ${value.toFixed(2)}`},
      //   { Header: (t("Receivable from Retailer")), accessor: "receivable_from_retailer",Cell: ({ value }) => `EGP ${value.toFixed(2)}`},
      {
        Header: (t("Settlement Status")), accessor: "settlement_status",
        Cell: ({ value }) => (
          <div className="text-start justify-start w-28">{t(formatSessionState(value))}</div>
        )
      },
      {
        Header: (t("Settlement Date")), accessor: "settlement_date", Cell: ({ value }) => (
          <div className="text-start justify-start w-28">{value}</div>
        )
      },
      {
        Header: (t("Payment Method")), accessor: "payment_method", Cell: ({ value }) => (
          <div className="text-start justify-start w-28">{t(formatSessionState(value))}</div>
        )
      },
      {
        Header: (t("Payment Notes")), accessor: "payment_note", Cell: ({ value }) => (
          <div className="text-start justify-start w-28">{t(formatSessionState(value))}</div>
        )
      },

      ...(allStores
        ? [
          {
            Header: (t("Store Name")),

            //  width: "6%", // Add this line
            //  width: "7%", // Add this line
            accessor: "store_name",
            headerClassName: "text-start",
            Cell: ({ row }) => (
              <div className="text-start justify-start w-28">{`EGP ${row.original.store_name}`}</div>
            ),
          },
        ]
        : []),
    ],
    [t]
  );

  const {
    headerGroups,
    prepareRow,
    page,
    nextPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data: data,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination,
    useRowSelect
  );

  const [pageIndex, setpageIndex] = useState(1);

  //   useEffect(() => {
  //     const pageDetails = {
  //       limit: pageSize,
  //       offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
  //     };

  //     if (pageSize) pagination(pageDetails);
  //   }, [pageSize, pageIndex]);

  return (
    <>
      <div
        className="container flex flex-col mx-auto mt-4"
        style={{ maxWidth: "100%" }}
      >
        {additionalData?.length == 0 && flag == false ? (
          <div className="h-screen w-[90%] mt-2 ">
            <ShimmerLoader />
          </div>
        ) : (
          <>
            {/* Header Table (Fixed) */}
            <div>
              <table
                className="font-normal  max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <thead>
                  {headerGroups.map((headerGroup, headerIndex) => {
                    const { key: headerKey, ...headerGroupProps } =
                      headerGroup.getHeaderGroupProps();
                    return (
                      <tr
                        key={headerKey}
                        {...headerGroupProps}
                        className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
                      >
                        {headerGroup.headers.map((column, colIndex) => {
                          const { key: columnKey, ...columnProps } =
                            column.getHeaderProps(
                              column.getSortByToggleProps()
                            );
                          return (
                            <th
                              key={columnKey}
                              {...columnProps}
                              className="py-3 whitespace-nowrap"
                              style={{ width: column.width }} // Set column width
                            >
                              <div className="flex items-start ms-2 text-xs ">
                                {column.render("Header")}
                                <span className="">
                                  {column.isSorted ? (
                                    column.isSortedDesc ? (
                                      <img
                                        src={Vectorsorting}
                                        style={{ minHeight: 10, minWidth: 10 }}
                                        alt="vector"
                                      />
                                    ) : (
                                      <img
                                        className="rotate-180"
                                        src={Vectorsorting}
                                        alt="vector"
                                      />
                                    )
                                  ) : (
                                    ""
                                  )}
                                </span>
                              </div>
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>
              </table>
            </div>
            {/* Body Table (Scrollable) */}
            <div
              className="scrollbar-none bg-white"
              style={{
                overflowY: "auto",
                maxHeight: "450px", // Adjust height as needed
              }}
            >
              <table
                className="font-normal max-w-[100%] sm:w-[97.6%]  md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <React.Fragment key={row.id}>
                        <tr
                          {...row.getRowProps()}
                          className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                        //   onClick={() => openOrderList(row.original.id)}
                        >
                          {row.cells.map((cell, index) => (
                            <td
                              key={index}
                              {...cell.getCellProps()}
                              className={`p-2 text-[#272728] h-1212 text-sm font-normal ${index < row.cells.length - 1 ? "relative" : ""
                                } ${cell?.column?.Header == "Product"
                                  ? "cursor-pointer"
                                  : ""
                                }`}
                            //   style={{ width: cell.column.width }} // Match column width
                            >
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      </React.Fragment>
                    );
                  })}
                  {page.length === 0 && (
                    <tr>
                      <td colSpan={"100%"}>
                        <Empty
                          className="mt-10"
                          description={t("No data available")}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            {/* <div className="">
              <CustomPagination
                data={data?.length}
                pageIndex={pageIndex}
                pageCount={page?.length}
                canPreviousPage={pageIndex != 1 ? true : false}
                canNextPage={data?.length == pageSize ? true : false}
                gotoPage={(page) => {
                  nextPage(page);
                }}
                previousPage={() => {
                  setpageIndex(pageIndex - 1);
                }}
                nextPage={() => {
                  setpageIndex(pageIndex + 1);
                }}
                pageSize={pageSize}
                setPageSize={(pageSize) => {
                  setPageSize(pageSize);
                }}
              />
            </div> */}
          </>
        )}
      </div>
    </>
  );
};

export default SettlementReportTable;
